import React from 'react';

interface ProgressBarProps {
  percentage: number;
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'secondary';
  showLabel?: boolean;
  height?: 'sm' | 'md' | 'lg';
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  percentage, 
  color = 'primary', 
  showLabel = false,
  height = 'md'
}) => {
  const heightClasses = {
    sm: 'h-2',
    md: 'h-4',
    lg: 'h-6'
  };

  const colorClasses = {
    primary: 'bg-primary-500 dark:bg-primary-600',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-error',
    secondary: 'bg-secondary-500 dark:bg-secondary-600'
  };

  return (
    <div className="flex items-center gap-2">
      <div className={`progress-bar flex-1 ${heightClasses[height]}`}>
        <div 
          className={`progress-bar-fill ${colorClasses[color]}`}
          style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-sm text-gray-600 dark:text-gray-400 min-w-[40px]">
          {percentage.toFixed(0)}%
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
